import React, { useMemo, useState } from "react";
import Button from "../components/common/button";
import Header from "../components/common/header";
import Loader from "../components/common/Loader";
import TabsComponent from "../components/Dashboard/TabsComponent";
import { useCoinsContext } from "../context/CoinsContext";

function readWatchlistIds() {
  try {
    const raw = localStorage.getItem("watchlist");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function WatchlistPage() {
  const [watchlistIds] = useState(() => readWatchlistIds());
  const { coins, loading } = useCoinsContext();

  const myWatchlist = useMemo(
    () =>
      watchlistIds.length
        ? coins.filter((item) => watchlistIds.includes(item.id))
        : [],
    [coins, watchlistIds]
  );

  if (watchlistIds.length === 0) {
    return (
      <div>
        <Header />
        <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>
          No Items in the Watchlist
        </h1>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a href="/dashboard">
            <Button text={"Dashboard"} onClick={() => {}} />
          </a>
        </div>
      </div>
    );
  }

  if (loading) {
    return <Loader />;
  }

  if (myWatchlist.length === 0) {
    return (
      <div>
        <Header />
        <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>
          No Items in the Watchlist
        </h1>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <a href="/dashboard">
            <Button text={"Dashboard"} onClick={() => {}} />
          </a>
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: "95vh" }}>
      <Header />
      <TabsComponent coins={myWatchlist} isWatchlistPage={true} />
    </div>
  );
}

export default WatchlistPage;
